(function () {
    if (window.__ccAdvanceLoaded) { return; }
    window.__ccAdvanceLoaded = true;

    var STATE_PREFIX = 'ccAdvState:';
    var ATTR_REQUIRED = 'Advance Payment Required';
    var ATTR_AGREED = 'Customer Agreed To Advance';
    var ATTR_AMOUNT = 'Advance Amount Due';
    var ATTR_HANDPAINTED = 'Hand Painted (100% Advance)';
    var ATTR_SHIPPING = 'Delivery Charges';
    var ATTR_CONFIRMED = '_Advance Confirmed Total';
    var ATTR_HP_AGREED = '_Hand Painted Terms Agreed';

    var modal = document.getElementById('AdvanceNotice');
    if (!modal) { return; }
    var CFG = modal.dataset;
    var THRESHOLD = parseInt(CFG.threshold, 10);
    var PERCENT = parseInt(CFG.percent, 10);
    var HP_ENABLE = CFG.hpEnable === 'true';
    var HP_COLLECTION = CFG.hpCollection;
    var SHIP_TIERS = CFG.shipTiers || '';
    var SHIP_COUNTRY = CFG.shipCountry || 'Pakistan';
    var SHIP_PROVINCE = CFG.shipProvince || '';
    var SHIP_ZIP = CFG.shipZip || '';
    /* End of the Shopify discount "Free Delivery on orders above Rs 2,000". */
    var FREE_UNTIL = Date.parse('2026-10-09T18:59:59Z');

    var TXT = {
      noticeHeading: CFG.noticeHeading,
      noticeCheck: CFG.noticeCheck,
      noticeBtn: CFG.noticeBtn,
      hpHeading: CFG.hpHeading,
      hpCheck: CFG.hpCheck,
      finalHeading: CFG.finalHeading,
      finalBtn: CFG.finalBtn
    };

    var titleEl = document.getElementById('AdvanceNoticeTitle');
    var box = document.getElementById('AdvanceAgreeBox');
    var checkLabel = document.getElementById('AdvCheckLabel');
    var checkRow = modal.querySelector('.adv-check');
    var listNormal = document.getElementById('AdvList');
    var listHp = document.getElementById('AdvListHp');
    var btn = document.getElementById('AdvanceAgreeBtn');
    var summary = document.getElementById('AdvSummary');
    var cartTotal = 0;
    var hpTotal = 0;       /* value of hand painted (made-to-order) items */
    var shipTotal = 0;     /* delivery charge for the current cart */
    var cartKey = '';
    var cartAttrs = {};
    var mode = 'notice';
    var writing = false;
    var userStamping = false;   /* a customer-driven save is in flight */
    var memState = {};

    var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

    /* ---- hand painted product ids, read once from the collection ---- */
    var hpIdsPromise = null;
    function hpIds() {
      if (!HP_ENABLE || !nativeFetch) { return Promise.resolve({}); }
      if (!hpIdsPromise) {
        hpIdsPromise = nativeFetch('/collections/' + HP_COLLECTION + '/products.json?limit=250', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var map = {};
            (j.products || []).forEach(function (p) { map[p.id] = true; });
            return map;
          })
          .catch(function () { return {}; });
      }
      return hpIdsPromise;
    }

    /* One memory per cart (cart token), kept in localStorage so it survives
       new tabs, Facebook/Instagram in-app browsers and coming back later.
       States: '' (never shown) -> 'seen' (shown, closed) -> 'agreed'. */
    var RANK = { '': 0, 'seen': 1, 'agreed': 2 };
    function storeKey() { return STATE_PREFIX + (cartKey || 'nocart'); }
    function getState() {
      var s = memState[storeKey()] || '';
      try { var ls = localStorage.getItem(storeKey()) || ''; if (RANK[ls] > RANK[s]) { s = ls; } } catch (e) {}
      try { var ss = sessionStorage.getItem(storeKey()) || ''; if (RANK[ss] > RANK[s]) { s = ss; } } catch (e) {}
      if (cartAttrs[ATTR_AGREED] === 'Yes') { s = 'agreed'; }
      return s;
    }
    function setState(next) {
      if (RANK[next] <= RANK[getState()]) { return; }
      memState[storeKey()] = next;
      try { localStorage.setItem(storeKey(), next); } catch (e) {}
      try { sessionStorage.setItem(storeKey(), next); } catch (e) {}
    }
    function isAgreed() { return getState() === 'agreed'; }

    function writeAttributes(attrs) {
      if (!nativeFetch) { return Promise.resolve(); }
      writing = true;
      return nativeFetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.attributes) { cartAttrs = c.attributes; } })
        .catch(function () {})
        .then(function () { writing = false; });
    }

    function money(minor) { return 'Rs ' + Math.round(minor / 100).toLocaleString('en-US'); }

    /* ---- delivery charge ----------------------------------------------
       The written rates (e.g. "0-4999:330;15000+:0", in rupees) give an
       instant answer; Shopify's own rate for this cart is then fetched and
       used instead, so changing the rates in Shopify needs no code change. */
    function shippingFromTiers(total) {
      var rules = SHIP_TIERS.split(';');
      for (var i = 0; i < rules.length; i++) {
        var parts = rules[i].split(':');
        if (parts.length !== 2) { continue; }
        var range = parts[0].replace(/\s/g, '');
        var price = parseFloat(parts[1]) * 100;
        if (isNaN(price)) { continue; }
        var open = range.indexOf('+') !== -1;
        var bounds = range.replace('+', '').split('-');
        var min = parseFloat(bounds[0]) * 100;
        var max = open ? Infinity : parseFloat(bounds[1]) * 100;
        if (isNaN(min)) { continue; }
        if (total >= min && total <= (isNaN(max) ? Infinity : max)) { return price; }
      }
      return 0;
    }

    var shipCache = {};
    /* Shopify's answer if it arrives quickly, the written rates otherwise. */
    function shippingFor(total) {
      if (total <= 0) { return Promise.resolve(0); }
      /* Free delivery is given by a Shopify discount, which the shipping
         rates lookup does not apply. When the written rates say this cart
         ships free, show Rs 0 exactly as checkout will. Only until the
         discount ends (Fri 9 Oct 23:59 PKT); after that Shopify's own rate
         is used again. */
      if (SHIP_TIERS && Date.now() <= FREE_UNTIL && shippingFromTiers(total) === 0) { return Promise.resolve(0); }
      if (shipCache[total] !== undefined) { return Promise.resolve(shipCache[total]); }
      var fallback = new Promise(function (resolve) {
        setTimeout(function () { resolve(shippingFromTiers(total)); }, 2500);
      });
      return Promise.race([
        liveShipping(total).then(function (v) {
          return v === undefined ? shippingFromTiers(total) : v;
        }),
        fallback
      ]);
    }

    function liveShipping(total) {
      if (!nativeFetch || shipCache[total] !== undefined) {
        return Promise.resolve(shipCache[total]);
      }
      var q = '/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' + encodeURIComponent(SHIP_COUNTRY);
      if (SHIP_PROVINCE) { q += '&shipping_address%5Bprovince%5D=' + encodeURIComponent(SHIP_PROVINCE); }
      if (SHIP_ZIP) { q += '&shipping_address%5Bzip%5D=' + encodeURIComponent(SHIP_ZIP); }
      return nativeFetch(q, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var rates = j.shipping_rates || [];
          if (!rates.length) { return undefined; }
          var cheapest = rates.reduce(function (a, b) {
            return parseFloat(b.price) < parseFloat(a.price) ? b : a;
          });
          var minor = Math.round(parseFloat(cheapest.price) * 100);
          if (isNaN(minor)) { return undefined; }
          shipCache[total] = minor;
          return minor;
        })
        .catch(function () { return undefined; });
    }

    /* Hand painted items are made to order: 100% of them is due up front.
       The rest of the cart follows the normal rule — PERCENT% when that
       part is itself over the threshold. */
    function normalTotal() { return Math.max(cartTotal - hpTotal, 0); }
    function normalDue() { return normalTotal() >= THRESHOLD ? normalTotal() * PERCENT / 100 : 0; }
    function goodsDue() { return hpTotal + normalDue(); }
    /* Delivery is normally collected by the rider with the COD balance.
       When nothing is left for the rider to collect (a hand painted only
       order), the delivery charge must be paid in advance too. */
    function shipInAdvance() { return goodsDue() > 0 && cartTotal - goodsDue() <= 0 ? shipTotal : 0; }
    function advanceDue() { return goodsDue() + shipInAdvance(); }
    function orderTotal() { return cartTotal + shipTotal; }
    function codBalance() { return Math.max(orderTotal() - advanceDue(), 0); }
    function needsAdvance() { return goodsDue() > 0; }
    function amountText() { return money(advanceDue()) + ' of ' + money(orderTotal()); }

    function confirmedKey() { return 'ccAdvConfirmed:' + (cartKey || 'nocart'); }
    function confirmedTotal() {
      var v = cartAttrs[ATTR_CONFIRMED];
      if (!v) { try { v = localStorage.getItem(confirmedKey()); } catch (e) {} }
      return v ? parseInt(v, 10) : -1;
    }

    /* A separate memory for the hand painted terms (no COD, 15 days). A
       customer who agreed to the plain % rule has NOT agreed to these, so
       adding a hand painted item later must ask them again — once. */
    function hpAgreedKey() { return 'ccAdvHpAgreed:' + (cartKey || 'nocart'); }
    function hpShownKey() { return 'ccAdvHpShown:' + (cartKey || 'nocart'); }
    function hpAgreed() {
      if (cartAttrs[ATTR_HP_AGREED] === 'Yes') { return true; }
      try { return localStorage.getItem(hpAgreedKey()) === '1'; } catch (e) { return false; }
    }
    function hpNoticeShown() {
      if (memState[hpShownKey()]) { return true; }
      try { return localStorage.getItem(hpShownKey()) === '1'; } catch (e) { return false; }
    }
    function markHpNoticeShown() {
      memState[hpShownKey()] = true;
      try { localStorage.setItem(hpShownKey(), '1'); } catch (e) {}
    }

    /* withConfirm = true only when the customer themself presses a popup
       button; silent background updates never move the confirmed total. */
    function stampAgreed(withConfirm) {
      var stamp = {};
      if (hpTotal > 0 && normalDue() > 0) {
        stamp[ATTR_REQUIRED] = 'Hand painted 100% + ' + PERCENT + '% on the rest';
      } else if (hpTotal > 0) {
        stamp[ATTR_REQUIRED] = 'Hand painted 100% before production';
      } else {
        stamp[ATTR_REQUIRED] = PERCENT + '% before dispatch';
      }
      stamp[ATTR_AGREED] = 'Yes';
      stamp[ATTR_AMOUNT] = amountText();
      stamp[ATTR_HANDPAINTED] = hpTotal > 0 ? money(hpTotal) + ' — made to order, no COD, dispatch after 15 days' : '';
      stamp[ATTR_SHIPPING] = shipTotal > 0
        ? money(shipTotal) + (shipInAdvance() > 0 ? ' — included in the advance' : ' — collected by the rider')
        : '';
      if (withConfirm) {
        stamp[ATTR_CONFIRMED] = String(cartTotal);
        try { localStorage.setItem(confirmedKey(), String(cartTotal)); } catch (e) {}
        if (hpTotal > 0) {
          stamp[ATTR_HP_AGREED] = 'Yes';
          try { localStorage.setItem(hpAgreedKey(), '1'); } catch (e) {}
        }
      } else {
        /* A silent update must never wipe what the customer confirmed:
           two writes can overlap, so carry the values forward. */
        var keep = confirmedTotal();
        if (keep >= 0) { stamp[ATTR_CONFIRMED] = String(keep); }
        if (hpAgreed()) { stamp[ATTR_HP_AGREED] = 'Yes'; }
      }
      return writeAttributes(stamp);
    }

    function paintSummary() {
      var label = (mode === 'final') ? 'Final cart total: ' : 'Cart total: ';
      var html = label + money(cartTotal);
      if (shipTotal > 0) { html += '<br>Delivery charges: ' + money(shipTotal); }
      if (hpTotal > 0) {
        html += '<br>Hand painted items (100% advance): ' + money(hpTotal);
        if (normalDue() > 0) { html += '<br>Other items (' + PERCENT + '% advance): ' + money(normalDue()); }
        if (shipInAdvance() > 0) { html += '<br>Delivery (paid in advance): ' + money(shipInAdvance()); }
      }
      html += '<b>Advance to pay now: ' + money(advanceDue()) + '</b>' +
        'Balance on delivery (COD): ' + money(codBalance());
      summary.innerHTML = html;
    }

    function openModal(which) {
      if (modal.classList.contains('is-open')) { return; }
      mode = which;
      var final = (mode === 'final');
      var hp = hpTotal > 0;
      titleEl.textContent = final ? TXT.finalHeading : (hp ? TXT.hpHeading : TXT.noticeHeading);
      checkLabel.textContent = hp ? TXT.hpCheck : TXT.noticeCheck;
      btn.textContent = final ? TXT.finalBtn : TXT.noticeBtn;
      listNormal.style.display = hp ? 'none' : '';
      listHp.style.display = hp ? '' : 'none';
      /* Stage 1 needs the tick box. Stage 2 is just the bill + one button. */
      checkRow.style.display = final ? 'none' : '';
      box.checked = false;
      btn.disabled = !final;
      paintSummary();
      modal.classList.add('is-open');
      document.documentElement.classList.add('adv-modal-open');
      modal.querySelector('.adv-box').scrollTop = 0;
      setState('seen');
      if (hp && !final) { markHpNoticeShown(); }
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('adv-modal-open');
    }

    function readCart(c) {
      cartTotal = c.total_price || 0;
      cartKey = String(c.token || '').split('?')[0];
      cartAttrs = c.attributes || {};
      return hpIds().then(function (map) {
        hpTotal = 0;
        (c.items || []).forEach(function (i) {
          if (map[i.product_id]) {
            hpTotal += (typeof i.final_line_price === 'number' ? i.final_line_price : i.line_price) || 0;
          }
        });
        return shippingFor(cartTotal);
      }).then(function (ship) {
        shipTotal = ship || 0;
        return c;
      });
    }

    function refresh(autoOpen) {
      if (!nativeFetch) { return Promise.resolve(); }
      return nativeFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(readCart)
        .then(function (c) {
          var flagged = !!(cartAttrs[ATTR_REQUIRED] || cartAttrs[ATTR_AGREED] || cartAttrs[ATTR_AMOUNT] || cartAttrs[ATTR_CONFIRMED] || cartAttrs[ATTR_HANDPAINTED] || cartAttrs[ATTR_HP_AGREED] || cartAttrs[ATTR_SHIPPING]);

          if (!needsAdvance()) {
            /* Nothing due up front: remove the advance tags from the order,
               but remember the customer's answer so it never asks again. */
            if (cartAttrs[ATTR_AGREED] === 'Yes') { setState('agreed'); }
            if (flagged && !writing) {
              var blank = {};
              blank[ATTR_REQUIRED] = '';
              blank[ATTR_AGREED] = '';
              blank[ATTR_AMOUNT] = '';
              blank[ATTR_HANDPAINTED] = '';
              blank[ATTR_SHIPPING] = '';
              blank[ATTR_CONFIRMED] = '';
              blank[ATTR_HP_AGREED] = '';
              try {
                localStorage.removeItem(confirmedKey());
                localStorage.removeItem(hpAgreedKey());
                localStorage.removeItem(hpShownKey());
              } catch (e) {}
              memState[hpShownKey()] = false;
              writeAttributes(blank);
            }
            return c;
          }

          /* A hand painted item has joined a cart the customer agreed to
             under the plain % rule: ask once for the hand painted terms. */
          if (hpTotal > 0 && !hpAgreed() && !hpNoticeShown()) {
            if (autoOpen) { openModal('notice'); }
            return c;
          }

          if (isAgreed()) {
            /* Already agreed for this cart: no popup, just keep the order
               tags and the advance amount up to date silently. */
            if (!writing && !userStamping && (cartAttrs[ATTR_AGREED] !== 'Yes' || cartAttrs[ATTR_AMOUNT] !== amountText())) {
              stampAgreed(false);
            }
            return c;
          }

          if (autoOpen && getState() === '') { openModal('notice'); }
          return c;
        })
        .catch(function () {});
    }

    var CART_RE = /\/cart\/(add|change|update|clear)/;
    var refreshTimer = null;
    function queueRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () { refresh(true); }, 300);
    }
    if (window.fetch) {
      var patchedFrom = window.fetch;
      window.fetch = function () {
        var a0 = arguments[0];
        var url = (a0 && a0.url) ? a0.url : (typeof a0 === 'string' ? a0 : '');
        var p = patchedFrom.apply(this, arguments);
        if (CART_RE.test(url)) {
          p.then(queueRefresh).catch(function () {});
        }
        return p;
      };
    }
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && CART_RE.test(url)) {
        this.addEventListener('load', queueRefresh);
      }
      return origOpen.apply(this, arguments);
    };

    ['cart:updated', 'cart:build', 'ajaxProduct:added', 'cart:refresh'].forEach(function (evt) {
      document.addEventListener(evt, queueRefresh);
    });

    function goToCheckout() { window.location.href = '/checkout'; }

    function interceptCheckout(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      Promise.resolve(refresh(false)).then(function () {
        if (!needsAdvance()) { goToCheckout(); return; }
        /* Case 1: customer agreed and the cart has NOT changed since
           -> no second popup, go straight to checkout. */
        if (isAgreed() && confirmedTotal() === cartTotal && (hpTotal === 0 || hpAgreed())) {
          var done = false;
          var go = function () { if (done) { return; } done = true; goToCheckout(); };
          if (cartAttrs[ATTR_AGREED] === 'Yes' && cartAttrs[ATTR_AMOUNT] === amountText()) { go(); return; }
          stampAgreed(false).then(go);
          setTimeout(go, 2500);
          return;
        }
        /* Case 2: cart changed after agreeing (kept shopping), or never
           agreed -> show the bill with the updated advance and a single
           Continue To Checkout button. No tick box. */
        openModal('final');
      });
    }

    var CHECKOUT_SEL = '[name="checkout"], .cart__checkout, .additional-checkout-button, .shopify-payment-button__button, a[href$="/checkout"]';
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) { return; }
      if (modal.contains(e.target)) { return; }
      var hit = e.target.closest(CHECKOUT_SEL);
      if (!hit) { return; }
      // Never touch an add-to-cart control, whatever classes it carries.
      if (hit.name === 'add' || e.target.closest('[name="add"], form[action*="/cart/add"]')) { return; }
      interceptCheckout(e);
    }, true);

    // Only a real checkout submission is intercepted. An add-to-cart form
    // (action="/cart/add") or a quantity update must pass through untouched.
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) { return; }
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1) { return; }
      if (!/\/cart(\?|#|$)/.test(action)) { return; }
      var submitter = e.submitter;
      if (submitter && submitter.name && submitter.name !== 'checkout') { return; }
      interceptCheckout(e);
    }, true);

    box.addEventListener('change', function () { btn.disabled = !box.checked; });

    btn.addEventListener('click', function () {
      if (mode !== 'final' && !box.checked) { return; }
      setState('agreed');
      /* Re-read the cart first so the confirmed total can never be stale. */
      userStamping = true;
      var p = Promise.resolve(refresh(false))
        .then(function () { return stampAgreed(true); })
        .then(function () { userStamping = false; });
      if (mode === 'final') {
        btn.disabled = true;
        var done = false;
        var go = function () { if (done) { return; } done = true; goToCheckout(); };
        p.then(go);
        setTimeout(go, 2500);
      } else {
        closeModal();
      }
    });

    modal.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.adv-copy') : null;
      if (!c) { return; }
      var val = c.getAttribute('data-copy') || '';
      var done = function () {
        var old = c.textContent;
        c.textContent = 'Copied';
        setTimeout(function () { c.textContent = old; }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = val;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        ta.remove();
      }
    });

    modal.querySelector('.adv-x').addEventListener('click', closeModal);
    modal.querySelector('.adv-overlay').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) { closeModal(); }
    });

    refresh(true);
  })();
